export function filterMoney(val) {
  return Number(val).toLocaleString('es', { style: 'decimal', currency: 'COP' });
}
